export const convertLocalDateTime = (localDateTime) => {
  if (!localDateTime) return "";

  const date = new Date(localDateTime);
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString();
  let day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;

  return month + "/" + day + "/" + year;
};

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(today.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const getDateFromStr = (dateStr) => {
  let date = new Date();
  if (dateStr) {
    const [year, month, day] = dateStr.split("-");
    date = new Date(+year, month - 1, +day); // Note: month is 0-based
  }
  const formatted = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return formatted;
};

export const isTimeDue = (dateString) => {
  const givenDate = new Date(dateString);
  const currentDate = new Date();

  if (isNaN(givenDate)) {
    throw new Error("Invalid date string");
  }

  return givenDate < currentDate;
};
